import { useEffect } from "react";
import logo from "../assets/logo_saha.png";
import image1 from "../assets/local/1.png";
import image2 from "../assets/local/2.png";
import image3 from "../assets/local/3.png";
import image4 from "../assets/local/4.jpg";
import image5 from "../assets/local/5.png";
import image6 from "../assets/local/6.jpg";
import image7 from "../assets/local/7.jpg";
import image8 from "../assets/local/8.jpg";
import image9 from "../assets/local/9.jpg";
import image10 from "../assets/local/10.jpg";
import image11 from "../assets/local/11.jpg";
import image12 from "../assets/local/12.jpg";
import "./KurulumKilavuzu.css";

const steps = [
    {
        image: image1,
        description: (
            <>
                Sportive Saha uygulamasının kurulumu ve kişiye özel bilgilerinizi alabilmek için{" "}
                <a
                    href="https://info.sportivespor.com.tr/mobil-kurulum"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    linke tıklayınız.
                </a>
            </>
        )
    },
    {
        image: image2,
        description: "İşe girişte İnsan Kaynakları Departmanı'na vermiş olduğunuz e-posta adresini girin, kullandığınız telefonun platformunu seçin ve “Doğrulama kodu gönder” butonuna basın."
    },
    {
        image: image3,
        description: "Girdiğiniz e-posta adresi doğruysa sistem adresinize bir doğrulama kodu gönderecektir. Kodu bu ekrana yazıp “Doğrula ve bilgileri gönder” butonuna basın."
    },
    {
        image: image4,
        description: "E-posta adresiniz doğruysa aşağıdaki gibi bir ileti alacaksınız. Buradaki doğrulama kodunu 3. adımdaki doğrulama ekranına girin."
    },
    {
        image: image5,
        description: "Doğrulama kodunu doğru girerek işlemi tamamladığınızda kurulum için gereken bilgiler e-posta adresinize iletilecektir. Bu bilgiler size özeldir ve kimseyle paylaşılmamalıdır. Uygulama linki kısmındaki bağlantıya tıklayarak uygulamayı telefonunuza kurunuz."
    },
    {
        image: image6,
        description: "Bu ekrana girmeniz gereken bilgiler 5. adımda gönderilen e-postada yer almaktadır. Bilgilerin eksiksiz ve doğru şekilde girilmesi gerekmektedir."
    },
    {
        image: image7,
        description: "Bilgilerin girilmiş hâlinin örnek görüntüsü aşağıdaki gibidir. Bilgileri girdikten sonra “Kaydet” butonuna basınız."
    },
    {
        image: image8,
        description: "Girdiğiniz bilgiler doğruysa aşağıdaki bilgilendirme ekranı açılacaktır. “Tamam” butonuna basınız."
    },
    {
        image: image9,
        description: "Şifrenizi oluşturmak için bu ekrandaki “Şifremi Unuttum” bölümüne giriniz."
    },
    {
        image: image10,
        description: "Şifre sıfırlama ekranında 1. adımda kullandığınız e-posta adresini girip “Doğrulama kodu gönder” butonuna basınız."
    },
    {
        image: image11,
        description: "E-posta adresinize gelen doğrulama kodunu ve belirlediğiniz yeni şifreyi yazarak “Şifreyi Güncelle” butonuna basın. Şifreniz, aşağıda yeşil renkte gösterilen kriterlerin tamamını karşılamalıdır. Karşılanmayan kriterler kırmızı renkte görünmektedir."
    },
    {
        image: image12,
        description: "Giriş ekranında e-posta adresinizi ve yeni belirlediğiniz şifrenizi girin. “Beni Hatırla” seçeneğini işaretlerseniz sonraki girişlerinizde bu bilgileri tekrar yazmanız gerekmez."
    }
];

export default function KurulumKilavuzu() {
    useEffect(() => {
        const previousLanguage = document.documentElement.lang;
        document.documentElement.lang = "tr";

        const meta = document.createElement("meta");
        meta.name = "google";
        meta.content = "notranslate";
        document.head.appendChild(meta);

        return () => {
            document.documentElement.lang = previousLanguage;
            meta.remove();
        };
    }, []);

    return (
        <main className="kilavuz-page notranslate" translate="no" lang="tr">
            <header className="kilavuz-header">
                <img src={logo} alt="Sportive Saha" />
                <h1>Kurulum Kılavuzu</h1>
            </header>

            <section className="kilavuz-steps" aria-label="Kurulum adımları">
                {steps.map((step, index) => (
                    <article className="kilavuz-step" key={step.image}>
                        <h2>{index + 1}. Adım</h2>
                        <p>{step.description}</p>
                        <img
                            src={step.image}
                            alt={`Kurulum kılavuzu ${index + 1}. adım ekran görüntüsü`}
                            loading={index > 1 ? "lazy" : "eager"}
                        />
                    </article>
                ))}
            </section>

            <footer className="kilavuz-welcome">Sportive SAHA’ya Hoş Geldiniz.</footer>
        </main>
    );
}
